/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { FileBlock, FileType } from "src/classes/block/block-types";
import { StandardFilePreview } from "src/components/Block/BlockTypes/FileBlock/StandardFilePreview";
import {
  StyledFileBlockContent,
  FileName,
  FileBlockWrapper,
} from "src/components/Block/BlockTypes/FileBlock/styles";
import { AudioWidget } from "src/components/Block/BlockTypes/FileBlock/Widgets/AudioWidget";
import { VideoWidget } from "src/components/Block/BlockTypes/FileBlock/Widgets/VideoWidget";
import { PDFBlock } from "src/components/Block/BlockTypes/PDFBlock";
import { FileStatusWrapper } from "src/components/Block/BlockTypes/utility/FileStatusWrapper";
import { IconWrapper } from "src/components/Signup/SignupMethodButton";
import { AudioIcon } from "src/components/UI/Icons";

interface Props {
  block: FileBlock;
}

export function SFileBlockContent({ block }: Props) {
  return (
    <StyledFileBlockContent>
      <FileStatusWrapper block={block}>
        {(() => {
          switch (block.fileType) {
            case FileType.Audio:
              return (
                <FileBlockWrapper>
                  <IconWrapper>
                    <AudioIcon />
                  </IconWrapper>
                  <FileName>
                    {block.fileDisplayName} {`(${block.readableFileSize})`}
                  </FileName>
                  <AudioWidget block={block} disableMouse={false} />
                </FileBlockWrapper>
              );
            case FileType.Video:
              return <VideoWidget block={block} disableMouse={false} />;
            case FileType.PDF:
              return <PDFBlock block={block} disableMouse={false} />;
            case FileType.Other:
              return <StandardFilePreview block={block} />;
          }
        })()}
      </FileStatusWrapper>
    </StyledFileBlockContent>
  );
}
